import { Component, OnInit } from '@angular/core';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[];

    constructor(public app: AppComponent, public appMain: AppMainComponent) { }

    ngOnInit() {
        this.model = [];

        this.model.push({
            label: 'NOVA SOLUÇÃO FINANCEIRA', icon: 'pi pi-fw pi-briefcase', routerLink: ['/view'], badge: 10,
            items: [
                { label: 'INTERFACES', icon: 'pi pi-fw pi-align-justify', routerLink: ['/gams/new-interfaces'] },
            ]
        });
    }
}
